import Phaser from 'phaser';

export default class PaintCanvas extends Phaser.GameObjects.Image {

  /**
   * 
   * @param {Phaser.Scene} scene 
   */
  constructor (scene) {
    const backingCanvas = scene.textures.createCanvas('paintcanvas', 100,100);

    super(scene, 0,0, 'paintcanvas');

    this.setOrigin(0);

    this.workingWidth = 110;
    this.workingHeight = 110;
    this.backingCanvas = backingCanvas;

    this.isDrawing = false;

    this.globalDrawPoints = [];

    this.drawCommands = [];

    /** @type {{mt: number[], ct: number[]}[]} */
    this.drawPoints = [];
    this.lastDrawPoint = { x: 0,y: 0 };
    this.drawOldPoint = { x: 0,y: 0 };
    this.drawOldMidPoint = { x: 0, y: 0 };
    this.midPoint = { x: 0, y: 0 };
  };

  reset(w,h) {
    this.drawCommands = [];
    this.globalDrawPoints = [];
    this.drawPoints = [];
    this.workingWidth = w;
    this.workingHeight = h;
    this.backingCanvas.clear();
    this.backingCanvas.setSize(w,h);
  };

  clear() {
    this.backingCanvas.clear();
    this.drawCommands = [];
    this.globalDrawPoints = [];
  };

  startDrawing(x,y) {
    this.drawCommands = [];
    this.globalDrawPoints = [];
    this.drawPoints = [];
    this.globalDrawPoints.push({ x, y });
    const localpoint = this.getLocalPoint(x,y);
    this.drawOldPoint.x = localpoint.x;
    this.drawOldPoint.y = localpoint.y;
    this.drawOldMidPoint = this.drawOldPoint;
    this.isDrawing = true;
    this.clear();

    this.handleDraw(x,y);
  };

  stopDrawing() {
    if (!this.isDrawing) return;
    this.isDrawing = false;
  };

  clearDrawing() {
    this.clear();
  };

  handleDraw(x,y) {
    if (!this.isDrawing) return;

    const localpoint = this.getLocalPoint(x, y);

    this.globalDrawPoints.push({ x, y });

    this.lastDrawPoint.x = x;
    this.lastDrawPoint.y = y;

    this.midPoint.x = this.drawOldPoint.x + localpoint.x >> 1;
    this.midPoint.y = this.drawOldPoint.y + localpoint.y >> 1;

    const ctx = this.backingCanvas.context;
    ctx.strokeStyle = '#000000';
    ctx.fillStyle = '#000000';
    ctx.lineWidth = 10;
    ctx.lineCap = 'round';

    ctx.beginPath();
    ctx.moveTo(this.midPoint.x, this.midPoint.y);
    ctx.quadraticCurveTo(this.drawOldPoint.x, this.drawOldPoint.y, this.drawOldMidPoint.x, this.drawOldMidPoint.y);
    ctx.stroke();

    this.backingCanvas.refresh();

    this.drawPoints.push({ mt: [this.midPoint.x, this.midPoint.y], ct: [this.drawOldMidPoint.x, this.drawOldPoint.y, this.drawOldMidPoint.x, this.drawOldMidPoint.y] });
    this.drawOldPoint.x = localpoint.x;
    this.drawOldPoint.y = localpoint.y;
    this.drawOldMidPoint.x = this.midPoint.x;
    this.drawOldMidPoint.y = this.midPoint.y;
  }
}